import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import {
  ValidatePartnershipCardFailure,
  ValidatePartnershipCardRequest,
  ValidatePartnershipCardSuccess,
} from './actions';
import { ValidationResponse } from '@models/swagger';

export const featureKey = 'validatePartnershipCard';

export interface State {
  data: ValidationResponse | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(ValidatePartnershipCardFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(ValidatePartnershipCardRequest, state => ({ ...state, error: null, loading: true })),
    on(ValidatePartnershipCardSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
